import { render, staticRenderFns } from "./arviointiasteikon-taso-tooltip.vue?vue&type=template&id=a8478398&"
import script from "./arviointiasteikon-taso-tooltip.vue?vue&type=script&lang=ts&"
export * from "./arviointiasteikon-taso-tooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports